export const DASHBOARD_COMPONENT = 'DASHBOARD_COMPONENT'